<form [formGroup]="form" (submit)="submit($event)" autocomplete="off" fxLayout="column" fxFlex="100%">
  <div formArrayName="configs">
    <mat-tab-group mat-align-tabs="start">
      <mat-tab *ngFor="let category of categories">
        <ng-template mat-tab-label>{{ 'tab.' + category | translate }}</ng-template>
        <div fxLayout="row wrap" fxLayoutGap="10px" fxFlex="100%" style="padding-top: 10px;">
          <div *ngFor="let configIndex of getConfigIndicesForCategory(category)" fxFlex="49%">
            <mat-card class="mat-elevation-z2" fxFlex="100%" fxLayoutGap="10px">
              <mat-card-content>
                <div [formGroupName]="configIndex" fxLayout="column" fxLayoutGap="10px">
                  <div fxFlex="100%">
                    <div fxLayout="row" fxLayoutGap="10px" fxFlex="100%">
                      <div fxFlex="30%" fxLayoutAlign="start center">{{ 'form.' + configs().controls[configIndex].value['key'] | translate }}</div>

                      <div fxFlex="70%">


                        <ng-container *ngIf="configurations.get(configs().controls[configIndex].value['key']).valueType === ConfigurationValueType.STRING_CRON">
                          <mat-form-field fxFlex.gt-sm="100%">
                            <mat-label>{{ 'form.' + configs().controls[configIndex].value['key'] + 'Hint' | translate }}</mat-label>
                            <input matInput placeholder="..." formControlName="value">
                          </mat-form-field>
                        </ng-container>

                        <ng-container *ngIf="configurations.get(configs().controls[configIndex].value['key']).valueType === ConfigurationValueType.STRING">
                          <mat-form-field fxFlex.gt-sm="100%">
                            <mat-label>{{ 'form.' + configs().controls[configIndex].value['key'] + 'Hint' | translate }}</mat-label>
                            <input matInput placeholder="..." formControlName="value">
                          </mat-form-field>
                        </ng-container>

                        <ng-container *ngIf="configurations.get(configs().controls[configIndex].value['key']).valueType === ConfigurationValueType.TEXTAREA">
                          <mat-form-field fxFlex.gt-sm="100%">
                            <mat-label>{{ 'form.' + configs().controls[configIndex].value['key'] + 'Hint' | translate }}</mat-label>
                            <textarea cdkTextareaAutosize matInput formControlName="value"></textarea>
                          </mat-form-field>
                        </ng-container>

                        <ng-container *ngIf="configurations.get(configs().controls[configIndex].value['key']).valueType === ConfigurationValueType.NUMBER">
                          <mat-form-field fxFlex.gt-sm="100%">
                            <mat-label>{{ 'form.' + configs().controls[configIndex].value['key'] + 'Hint' | translate }}</mat-label>
                            <input type="number" matInput formControlName="value">
                          </mat-form-field>
                        </ng-container>

                        <ng-container *ngIf="configurations.get(configs().controls[configIndex].value['key']).valueType === ConfigurationValueType.BOOLEAN">
                          <mat-checkbox color="primary" formControlName="value"></mat-checkbox>
                        </ng-container>

                        <ng-container *ngIf="configurations.get(configs().controls[configIndex].value['key']).valueType === ConfigurationValueType.COMBO_BOX">
                          <mat-form-field fxFlex.gt-sm="100%">
                            <mat-label>{{ 'form.' + configs().controls[configIndex].value['key'] + 'Hint' | translate }}</mat-label>
                            <mat-select formControlName="value">
                              <mat-option *ngFor="let option of configurations.get(configs().controls[configIndex].value['key']).comboBoxOptions" [value]="option">
                                {{ option }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>

                        <ng-container *ngIf="configurations.get(configs().controls[configIndex].value['key']).valueType === ConfigurationValueType.CATEGORY_TREE">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxFlex="100%">
                            <mat-form-field fxFlex="70%">
                              <mat-label>{{ 'form.' + configs().controls[configIndex].value['key'] + 'Hint' | translate }}</mat-label>
                              <input matInput formControlName="value" readonly placeholder="Wybierz kategorię...">
                            </mat-form-field>
                            <button type="button" mat-raised-button color="accent" (click)="openCategoryDialog(configIndex)">
                              <mat-icon>account_tree</mat-icon> Przeglądaj
                            </button>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <div *ngIf="category === 'InPost'" fxFlex="100%" style="padding-top: 10px;">
          <mat-card class="mat-elevation-z2">
            <mat-card-content>
              <div fxLayout="column" fxLayoutGap="12px">
                <div style="font-weight: 500; font-size: 14px;">Zarządzanie kategoriami InPost</div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                  <button type="button" mat-raised-button color="primary" (click)="refreshCategories()" [disabled]="categoriesRefreshing">
                    <mat-icon>refresh</mat-icon> {{ categoriesRefreshing ? 'Odświeżanie...' : 'Odśwież kategorie z API' }}
                  </button>
                  <button type="button" mat-raised-button color="warn" (click)="resetCategoryCache()" [disabled]="categoriesResetting">
                    <mat-icon>delete_sweep</mat-icon> {{ categoriesResetting ? 'Resetowanie...' : 'Resetuj cache kategorii' }}
                  </button>
                  <button type="button" mat-raised-button color="accent" (click)="reassignCategories()" [disabled]="categoriesReassigning">
                    <mat-icon>sync</mat-icon> {{ categoriesReassigning ? 'Reassign...' : 'Reassign kategorie' }}
                  </button>
                </div>
                <span *ngIf="categoriesRefreshResult" style="color: green; font-size: 12px;">
                  {{ categoriesRefreshResult }}
                </span>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <mat-card class="mat-elevation-z2" fxFlex="100%" style="margin-top: 10px;">
    <mat-card-content>
      <div fxLayout="row" fxLayoutAlign="end center">
        <button type="submit" mat-button mat-raised-button color="primary">Zapisz</button>
      </div>
    </mat-card-content>
  </mat-card>
  <br> <br> <br> <br>
</form>
